import { useMemo } from 'react'

import { F0Heading } from '@factorialco/f0-react'
import { DetailsItemsList } from '@factorialco/f0-react/dist/experimental'

import type { PurchaseOrderDetailFieldsFragment } from 'generated/resources/graphql'

import { sectionLabel } from 'modules/procurement/components/poTemplates/FieldEditor/translations'

import type { FieldWithValue } from 'modules/procurement/components/purchaseOrders/PurchaseOrderDetail/utils'
import {
  displayValue,
  resolveFieldLabel,
} from 'modules/procurement/components/purchaseOrders/PurchaseOrderDetail/utils'

interface Props {
  fields: FieldWithValue[]
  purchaseOrder: PurchaseOrderDetailFieldsFragment
}

function NotesDeliverySection({ fields, purchaseOrder }: Props) {
  const details = useMemo(
    () =>
      fields.map((field) => ({
        title: resolveFieldLabel(field.definition),
        content: {
          type: 'item' as const,
          text: displayValue(field, purchaseOrder) || '-',
        },
      })),
    [fields, purchaseOrder]
  )

  if (fields.length === 0) return null

  return (
    <>
      <F0Heading content={sectionLabel('notes_and_delivery')} as="h3" />
      <DetailsItemsList details={details} />
    </>
  )
}

export default NotesDeliverySection
